module.exports = __webpack_public_path__ + "202408221624/img/icon_tag_ join@3x.099437d8.png";